import * as React from "react"
import colors from "theme/colors"

const SvgComponent = ({
  color = colors.cherryRed,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const w = 30
  const h = 30
  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      width={w}
      height={h}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.2 9c.994 0 1.8.776 1.8 1.733v9.534c0 .957-.806 1.733-1.8 1.733H7.8c-.994 0-1.8-.776-1.8-1.733v-9.534C6 9.776 6.806 9 7.8 9h14.4Zm.777 1.296L15 17.124l-7.977-6.828a.838.838 0 0 0-.123.437v9.534c0 .085.013.168.037.246l1.448-1.448 1.448-1.447.648.649-1.425 1.425-1.425 1.426c.055.01.111.015.169.015h14.34L20.706 19.7l-1.433-1.433.649-.65 1.534 1.534 1.533 1.532a.838.838 0 0 0 .111-.416v-9.534a.839.839 0 0 0-.123-.437Zm-.854-.43H7.876L15 15.964l7.123-6.098Z"
        fill={color}
      />
    </svg>
  )
}

export default SvgComponent
